import { render } from "./Footer.vue?vue&type=template&id=b7b0d0a8&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=b7b0d0a8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b7b0d0a8"

export default script